import React from "react";
import { Layout } from "../../layouts/Layout";
import { BlogPageWrapper } from "../../components/BlogAreas/BlogPageWrapper";
import { blogDetailsPath, getBlogs } from "../../data/blogs";
import { useTranslation } from "react-i18next";
import { LocaleLink } from "../../i18n/LocaleLink";

const BlogPage = () => {
  const { t } = useTranslation();
  const blogs = getBlogs(t);
  return (
    <Layout footer={2} breadcrumb={t("pages.blog.breadcrumb")} title={t("pages.blog.title")}>
      <BlogPageWrapper>
        <div className="blog-post-wrap">
          {/* list */}
          <div className="row">
            {blogs.map((blog) => {
              const detailsTo = blogDetailsPath(blog.id);
              return (
              <div key={blog.id} className="col-md-6">
                <div className="blog-post-item-two">
                  <div className="blog-post-thumb-two">
                    <LocaleLink to={detailsTo}>
                      <img src={blog.src} alt="" />
                    </LocaleLink>
                    <LocaleLink to={blog.tagHref} className="tag tag-two">
                      {blog.tag}
                    </LocaleLink>
                  </div>

                  <div className="blog-post-content-two">
                    <h2 className="title">
                      <LocaleLink to={detailsTo}>{blog.title}</LocaleLink>
                    </h2>
                    <p>{blog.subtitle}</p>

                    <div className="blog-meta">
                      <ul className="list-wrap">
                        <li>
                          <LocaleLink to={detailsTo}>
                            <img src={blog.authorSrc} alt="" />
                            {blog.author}
                          </LocaleLink>
                        </li>
                        <li>
                          <i className="far fa-calendar"></i>
                          {blog.createdAt}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              );
            })}
          </div>

          {/* pagination */}
          {/* <div className="pagination-wrap mt-30">
            <nav aria-label="Page navigation example">
              <ul className="pagination list-wrap">
                <li className="page-item">
                  <a className="page-link" href="#">
                    <i className="fas fa-angle-double-left"></i>
                  </a>
                </li>
                <li className="page-item active">
                  <a className="page-link" href="#">
                    1
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    3
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    4
                  </a>
                </li>
                <li className="page-item next-page">
                  <a className="page-link" href="#">
                    <i className="fas fa-angle-double-right"></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div> */}
        </div>
      </BlogPageWrapper>
    </Layout>
  );
};

export default BlogPage;
